import type { OnboardingDataItemType } from "@memorang/constants/config/schema";
import { useTranslation } from "react-i18next";
import { List, Text } from "react-native-paper";
import { useAppTheme } from "../../useAppTheme";
import Box from "../Box";
import { ItemIcons } from "./components/FeatureItemIcon";
import { OnboardingBox } from "./components/OnboardingBox";
import { resolveI18n } from "./helpers";

type Props = {
	title: string;
	description: string | undefined;
	data: OnboardingDataItemType[] | undefined;
};

export const OnboardingPrivacyScreen = ({
	title,
	description,
	data = [],
}: Props) => {
	const theme = useAppTheme();
	const { i18n } = useTranslation();

	return (
		<OnboardingBox>
			<Box gap={14}>
				<Text variant="titleLarge">{title}</Text>
				{description ? <Text variant="bodyMedium">{description}</Text> : null}
			</Box>
			{data.length > 0 ? (
				<Box gap={12}>
					{data.map((item) => (
						<List.Item
							key={resolveI18n(item.titlei18n, "en-US")}
							title={resolveI18n(item.titlei18n, i18n.language)}
							description={resolveI18n(item.descriptioni18n, i18n.language)}
							left={() =>
								item.icon ? (
									<List.Icon
										icon={() => (
											<ItemIcons
												nameIcon={
													item.icon as React.ComponentProps<
														typeof ItemIcons
													>["nameIcon"]
												}
											/>
										)}
									/>
								) : null
							}
							style={{ padding: 0 }}
							containerStyle={{ margin: 0 }}
							titleStyle={{ fontSize: theme.fonts.labelLarge.fontSize }}
						/>
					))}
				</Box>
			) : null}
		</OnboardingBox>
	);
};
